import React, { FunctionComponent } from 'react';
import AtlassianSwitcher from '@atlaskit/atlassian-switcher';
import { IntlProvider } from 'react-intl';
import FabricAnalyticsListeners, {
  FabricChannel,
} from '@atlaskit/analytics-listeners';
import { Analytics } from '@trello/atlassian-analytics';
import { N300, N800 } from '@trello/colors';
import { ProductKeys } from '@atlassiansox/product-store-react';

import styles from './AtlassianAppSwitcher.less';

const trelloTheme = {
  primaryTextColor: N800,
  secondaryTextColor: N300,
  primaryHoverBackgroundColor: '#E0E2E5',
  secondaryHoverBackgroundColor: '#F5F6F7',
};

interface AtlassianAppSwitcherProps {
  triggerXFlow: (productKey: ProductKeys) => void;
  onDiscoverMoreClicked: () => void;
}

export const AtlassianAppSwitcher: FunctionComponent<AtlassianAppSwitcherProps> = ({
  triggerXFlow,
  onDiscoverMoreClicked,
}) => {
  const discoverySwitcherProps = {
    isDiscoverMoreForEveryoneEnabled: true,
    isDiscoverSectionEnabled: true,
    triggerXFlow,
    onDiscoverMoreClicked,
    recommendationsFeatureFlags: {
      isProductStoreInTrelloEnabled: true,
    },
  };
  return (
    <div className={styles.atlassianAppSwitcherContainer}>
      <IntlProvider locale="en">
        {
          //@ts-ignore
          <FabricAnalyticsListeners
            client={Analytics.dangerouslyGetAnalyticsWebClient()}
            excludedChannels={[
              FabricChannel.atlaskit,
              FabricChannel.elements,
              FabricChannel.editor,
              FabricChannel.media,
            ]}
          >
            {
              //@ts-ignore
              <AtlassianSwitcher
                product="trello"
                appearance="standalone"
                theme={trelloTheme}
                {...discoverySwitcherProps}
              />
            }
          </FabricAnalyticsListeners>
        }
      </IntlProvider>
    </div>
  );
};
